import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({ providedIn: 'root' })
export class UsersService {
  modifyUser(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/modifyuser`, payload);
  }

  constructor(private httpClient: HttpClient, private route: Router) { }
  scrollHeight: string = '22em'; // Set your common scroll height here
  baseproperties: Baseproperties = new Baseproperties();
  downloadObservable = new BehaviorSubject<any>(null);
  private baseURL = this.baseproperties.gatewayBaseURL + '/common';

  postuser(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/adduser`, payload);  // user Add
  }
  getuserxproductdetails(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getuserxproduct`, payload);
  }
  getproductxroledetails(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getproductxrole`, payload);
  }
  modifyuser(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/modifyuser`, payload);  // user update
  }
  getall_users(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getusers`, payload);
  }
  getProduct(payload: any): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/productdata`, payload);
  }
  getUserDataView_byId(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getuserbyid`,payload);
  }
  manuallyresetpassword(payload): Observable<any>{
        return this.httpClient.post(`${this.baseURL}/user/manuallyresetpassword`,payload);

  }
   getloggedinuseradminroleswithproducts(userid: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/getadminroles/${userid}`);
  }

  getLocationtype(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/forlist/usertype`);
  }
  userDataExcel() {

    return this.httpClient.get(`${this.baseURL}/user/userdashboardExcel`, { responseType: 'blob' });
  }
  getOptionDropdown(length): Array<any> {
    let options = []
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e) => {
      options.push({ 'label': e[0], value: e[0] })
    });
    return options
  }
  excelUploadFormat() {
    return this.httpClient.get(`${this.baseURL}/user/bulkuploadTempExcel`, { responseType: 'blob' });
  }
  getproductforlist(payload: any): Observable<any> {
    return this.httpClient.post<Observable<any>>(`${this.baseURL}/user/productdata`, payload);
  }
  getusersforlist(payload): Observable<any> {
    return this.httpClient.post<Observable<any>>(`${this.baseURL}/user/userdata`,payload);
  }

  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/user/getconfiguration`);
  }

  emergencyStop(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/emergencystop`, payload);
  }

   getgroupcompany(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/getgroupcompany`, payload);
  }


  emergencyStart(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/emergencystart`, payload);
  }

  getOrganisation(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/getorganisations`);
  }

  getDistinctProduct(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctproduct`);
  }

  getMappedCompany(managerId: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/getmappedcompany/${managerId}`);
  }

  getDistinctEntity(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctentity`);
  }

  getDistinctLocation(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctlocation`);
  }
  getDistinctDepartment(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctdepartment`);
  }
  getDistinctVertical(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctvertical`);
  }

  getDistinctStatus(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctstatus`);
  }

  getDistinctgroup(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/distinctgroup`);
  }

  getMappedGroup(managerId: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/user/getmappedclientgroup/${managerId}`);
  }

  getEntityList(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getentitylist`,payload);
  }
    getvertical(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/user/getvertical`,payload);
  }
   getdepartmentforlist(payload): Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/user/departmentdata`,payload);
      }
        getlocationforlist(payload): Observable<any> {
    return this.httpClient.post<Observable<any>>(`${this.baseURL}/user/forlist/loc`,payload);
  }

  syncData(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/user/syncdata`, payload);
  }
 
} 
